/*
 * File: 客户模块-客户管理-详情-一页纸-分段
 */
<template>
    <div class="paper-segment-box">
        <div class="paper-segment-left">
            <el-collapse v-if="renderedStreamDescription" v-model="activeNames">
                <el-collapse-item name="1">
                    <template slot="title">
                        <img src="@/assets/images/icon-think.png" alt="" style="width: 16px;height: 16px;margin-right: 3px;">
                        <span style="color: #666;">已深度思考</span>
                        <!-- <span style="color: #666;">{{ `已深度思考${partData.ai.runtime ? `(用时${partData.ai.runtime}秒)` : ''}` }}</span> -->
                    </template>
                    <div class="paper-ai-dot" />
                    <div class="paper-ai-think" v-html="renderedStreamDescription" />
                </el-collapse-item>
            </el-collapse>
            <h4>{{ partData.title }}</h4>
            <div :class="`paper-ai-content-${partData.type}`" v-html="renderedStreamContent" />
            <div v-if="!renderedStreamContent && !loading && partData.type !== 'part3'" style="color: #C0C4CC;">此部分内容为空，请维护</div>
            <div v-if="loading" style="text-align: center;color: #2881FF;">
                <span class="el-icon-loading" />
                <span style="margin-left: 4px;">加载中...</span>
            </div>
            <UploadFileList
                ref="uploadFileListRef"
                v-if="partData.type === 'part2'"
                bucket="annto-lcrm"
                :limit="1"
                accept="image/*"
                :needBtn="false"
                :disabled="disabled"
                :file-list="partData.fileList"
                list-type="picture-card"
                :on-exceed="handleExceed"
                :on-remove="handleRemove"
                @callback="handleUpload"
            >
                <i class="el-icon-plus" />
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
            </UploadFileList>
            <div v-if="partData.type === 'part3' && partData.fileContent" class="paper-segment-part3" style="width: 100%;" v-html="partData.fileContent" />
            <div v-if="partData.type === 'part3' && !partData.fileContent" class="paper-segment-part3" style="width: 100%;">
                <p v-if="partData.tableData1.length" style="margin-top: 0;">客户型谱</p>
                <table v-if="partData.tableData1.length" style="border: 1px solid #000;border-collapse: collapse;width: 100%;color: #555;text-align: center;">
                    <!-- 表头部分 -->
                    <thead>
                        <tr>
                            <th
                                v-for="(col, index) in config.columns"
                                :key="col.prop + index"
                                style="border: 1px solid #000;background-color: #EBEEF5;color: #000;height: 23px;font-size: 12px;font-weight: normal;"
                            >{{ col.label}}</th>
                        </tr>
                    </thead>
                    <!-- 表体部分 -->
                    <tbody>
                        <tr v-for="(data, index) in partData.tableData1" :key="data.categoryName + index">
                            <td style="border: 1px solid #000;padding: 0px 6px;font-size: 12px;">{{ data.categoryName }}</td>
                            <td style="border: 1px solid #000;padding: 0px 6px;font-size: 12px;">{{ data.customerTotalScale }}</td>
                            <td style="border: 1px solid #000;padding: 0px 6px;font-size: 12px;">{{ data.cooperationScale }}</td>
                            <td style="border: 1px solid #000;padding: 0px 6px;font-size: 12px;">{{ data.pendingCooperationScale }}</td>
                            <td style="border: 1px solid #000;padding: 0px 6px;font-size: 12px;">{{ data.pendingMajorCompetitors }}</td>
                        </tr>
                    </tbody>
                </table>
                <p v-if="partData.tableData2.length">{{ partData.tableSummary }}</p>
                <table v-if="partData.tableData2.length" style="border: 1px solid #000;border-collapse: collapse;width: 100%;color: #555;text-align: center;">
                    <!-- 表头部分 -->
                    <thead>
                        <tr v-for="(col, index) in config.columnsSecondary" :key="'表头' + index">
                            <th
                                v-for="(child, index1) in col"
                                :key="child.prop + index1"
                                v-bind="{ ...child.thProps }"
                                style="border: 1px solid #000;background-color: #EBEEF5;color: #000;height: 23px;font-size: 12px;font-weight: normal;"
                            >{{ child.label}}</th>
                        </tr>
                    </thead>
                    <!-- 表体部分 -->
                    <tbody>
                        <tr v-for="(data, index) in partData.tableData2" :key="data.companyName + index">
                            <td style="border: 1px solid #000;padding: 0px 6px;font-size: 12px;">{{ data.companyName }}</td>
                            <td style="border: 1px solid #000;padding: 0px 6px;font-size: 12px;">{{ data.businessCategory }}</td>
                            <td style="border: 1px solid #000;padding: 0px 6px;font-size: 12px;">{{ data.totalIncomeBefore2Y }}</td>
                            <td style="border: 1px solid #000;padding: 0px 6px;font-size: 12px;">{{ data.profitRateBefore2Y }}</td>
                            <td style="border: 1px solid #000;padding: 0px 6px;font-size: 12px;">{{ data.totalIncomeBefore1Y }}</td>
                            <td style="border: 1px solid #000;padding: 0px 6px;font-size: 12px;">{{ data.profitRateBefore1Y }}</td>
                            <td style="border: 1px solid #000;padding: 0px 6px;font-size: 12px;">{{ data.totalIncomeBefore0Y }}</td>
                            <td style="border: 1px solid #000;padding: 0px 6px;font-size: 12px;">{{ data.profitRateBefore0Y }}</td>
                        </tr>
                    </tbody>
                    <!-- 表尾合计行 -->
                    <tfoot>
                        <tr>
                            <td
                                v-for="(data, index) in getSummaries()"
                                :key="'表尾' + index"
                                style="border: 1px solid #000;padding: 0px 6px;font-size: 12px;"
                            >{{ data }}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div v-if="partData.type !== 'part3'" style="padding-top: 10px;">
                <el-button size="mini" @click="handleEditText" :disabled="disabled" style="background-color: #F5F5F5;padding: 10px 16px;">编辑文本</el-button>
                <el-button size="mini" @click="handleRegenerate" :disabled="disabled" style="background-color: #F5F5F5;padding: 10px 16px;">重新生成</el-button>
            </div>
        </div>
        <div v-if="partData.ai && partData.ai.datasource && partData.ai.datasource.length" class="paper-segment-right">
            <h4>资料来源</h4>
            <div v-for="(source, index) in partData.ai.datasource" :key="source.title + index">
                <el-tag type="info">{{ index + 1 }}</el-tag>
                <div class="paper-segment-right-link-box">
                    <el-link :href="source.link" target="_blank" :title="source.title">{{ source.title }}</el-link>
                    <div :title="source.link" class="paper-segment-right-link">{{ source.link }}</div>
                </div>
            </div>
        </div>

        <!-- 编辑文本 -->
        <EditTextDialog ref="editTextDialogRef" @confirm="handleConfirmEditText" />
        <!-- 重新生成 -->
        <RegenerateDialog ref="regenerateDialogRef" @confirm="handleConfirmRegenerate" />
    </div>
</template>

<script>
import { ref, reactive, watch, computed } from '@vue/composition-api';
import { processString } from '@/utils/format.js';
import EditTextDialog from './editTextDialog.vue';
import RegenerateDialog from './regenerateDialog.vue';
import UploadFileList from '@/components/lots/oss/UploadFileList.vue';
import { config as configStatic, markdownFormat, formatHtml } from '../config';
const md = markdownFormat();

export default {
    components: { EditTextDialog, RegenerateDialog, UploadFileList },
    props: {
        detailData: {
            type: Object,
            default() {
                return {};
            }
        },
        streamDescription: {
            type: String,
            default: '' // 兜底空字符串，避免undefined导致渲染错误
        },
        streamContent: {
            type: String,
            default: '' // 兜底空字符串，避免undefined导致渲染错误
        },
        oldContent: {
            type: String,
            default: '' // 旧数据,编辑需要用到
        },
        initContent: {
            type: String,
            default: '' // 旧数据,原文需要用到
        },
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const emit = setupContext.emit;
        const config = reactive(configStatic);
        const partData = ref({});
        const activeNames = ref([]);

        const renderedStreamDescription = computed(() => md.render(props.streamDescription));
        const renderedStreamContent = computed(() => md.render(props.streamContent));
        // 编辑文本
        const handleEditText = () => {
            setupContext.refs.editTextDialogRef.show(md.render(props.oldContent), md.render(props.initContent));
        };
        // 编辑文本弹窗回调
        const handleConfirmEditText = (content) => {
            const data = formatHtml(content);
            emit('updateContent', data);
        };
        // 重新生成
        const handleRegenerate = () => {
            setupContext.refs.regenerateDialogRef.show();
        };
        // 重新生成弹窗回调
        const handleConfirmRegenerate = (params) => {
            emit('updateData', {
                ai: {
                    datasource: [],
                    runtime: null,
                    activeNames: ['1']
                }
            });
            if (!renderedStreamContent.value) {
                emit('regenerate', { mode: 'generate', module_content: partData.value.module_content });
                return;
            }
            emit('regenerate', { content_to_modify: props.oldContent, ...params });
        };
        // 上传图片
        const handleUpload = (file) => {
            emit('updateData', { imgUrl: file?.data?.downUrl, fileList: [{ name: file?.data?.name, url: file?.data?.downUrl }] });
        };
        // 重新上传覆盖前一个图片
        const handleExceed = (files) => {
            setupContext.refs.uploadFileListRef.submitUpload({ file: files[0] });
        };
        // 删除图片
        const handleRemove = () => {
            emit('updateData', { imgUrl: '', fileList: [] });
        };
        // 表尾合计
        const getSummaries = () => {
            const sums = [];
            config.columnsSummaries.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (column.calcField) {
                    const profitValues = partData.value.tableData2.map((item) => processString(item[column.calcField[0]]));
                    const incomeValues = partData.value.tableData2.map((item) => processString(item[column.calcField[1]]));
                    if (!profitValues.every((value) => Number.isNaN(value)) && !incomeValues.every((value) => Number.isNaN(value))) {
                        const totalProfit = profitValues.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!Number.isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        const totalIncome = incomeValues.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!Number.isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] = ((totalProfit / totalIncome) * 100)?.toFixed(2) + '%';
                    } else {
                        sums[index] = '';
                    }
                } else {
                    const values = partData.value.tableData2.map((item) => processString(item[column.prop]));
                    if (!values.every((value) => Number.isNaN(value))) {
                        sums[index] = `${values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!Number.isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0)?.toFixed(2)}`;
                    } else {
                        sums[index] = '';
                    }
                }
            });

            return sums;
        };
        // 获取HTML
        const getHTML = () => document.querySelector(`.paper-ai-content-${partData.value.type}`)?.innerHTML;
        // 获取第三部分HTML
        const getPart3HTML = () => document.querySelector('.paper-segment-part3')?.innerHTML;

        watch(
            () => props.detailData,
            (val) => {
                partData.value = { ...val };
            },
            { deep: true, immediate: true }
        );

        watch(
            () => [props.loading, props.detailData],
            (val) => {
                // 折叠面板 加载中展开，加载完收缩
                activeNames.value = props.loading && props.detailData.ai?.activeNames ? props.detailData.ai?.activeNames : [];
            },
            { deep: true, immediate: true }
        );

        return {
            config,
            partData,
            renderedStreamDescription,
            renderedStreamContent,
            activeNames,
            handleEditText,
            handleConfirmEditText,
            handleRegenerate,
            handleConfirmRegenerate,
            handleUpload,
            handleExceed,
            handleRemove,
            getSummaries,
            getHTML,
            getPart3HTML
        };
    }
};
</script>

<style lang="less" scoped>
.paper-segment-box {
    width: calc(100% - 20px);
    background-color: #fff;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 10px;
    display: flex;
    .paper-segment-left {
        flex: 1;
        color: #000;
    }
    .paper-ai-dot {
        width: 5px;
        height: 5px;
        background-color: #999;
        border-radius: 50%;
        display: inline-block;
        vertical-align: top;
        margin-top: 20px;
        &::after {
            content: "";
            width: 1px;
            height: calc(100% - 40px);;
            background-color: rgba(0,0,0,0.1);
            position: absolute;
            top: 25px;
            left: 2px;
        }
    }
    .paper-ai-think {
        margin-left: 5px;
        color: #666;
        display: inline-block;
        width: calc(100% - 10px);
        max-height: 20vh;
        overflow-y: scroll;
    }
    img {
        width: 100%;
        height: 100%;
    }
    .paper-segment-right {
        width: 300px;
        border-left: 1px solid #f5f6f7;
        padding-left: 8px;
        margin-left: 8px;
    }
    .paper-segment-right-link-box {
        width: calc(100% - 30px);
        display: inline-block;
        margin-left: 8px;
    }
    .paper-segment-right-link {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #999;
    }
    h4 {
        margin: 12px 0;
        font-weight: normal;
    }
}
</style>
<style lang="less">
.paper-segment-box {
    .el-collapse, .el-collapse-item__header, .el-collapse-item__wrap {
        border: none;
    }
    .el-collapse-item__content {
        padding: 0;
        position: relative;
    }
    .el-collapse-item__arrow {
        margin: 0;
    }
    .upload-demo {
        text-align: center;
    }
    .el-upload {
        text-align: center;
    }
    .el-tag {
        border-radius: 50%;
        vertical-align: top;
        margin-top: 5px;
    }
    .el-link {
        width: 100%;
        margin-bottom: 10px;
        color: #333;
        margin: 0;
    }
    .el-link--inner {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .el-upload {
        position: relative;
    }
    .el-upload__tip {
        position: relative;
        bottom: 20px;
        line-height: 0;
    }
    .el-upload-list__item {
        width: 60% !important;
    }
}
/* 差异高亮样式 */
.diff-add {
  /* background-color: #d4edda; */
  color: red;
  text-decoration: none;
  padding: 2px 0;
  border-radius: 2px;
}

.diff-del {
  background-color: #f8d7da;
  color: #721c24;
  text-decoration: line-through;
  padding: 2px 0;
  border-radius: 2px;
}
</style>
